import { datadogRum } from '@datadog/browser-rum';
import BrowserCookies from './BrowserCookies';

type Context = Record<string, any>;

export type Options = {
  callback?: (_: Error) => void;
  controller?: AbortController;
};

const isLocalDevEnvironment = Boolean(process.env.IS_LOCAL);

function logToConsole(error: Error, context?: Context) {
  // eslint-disable-next-line no-console
  console.error({
    message: error.message,
    stack: error.stack,
    context
  });
}

function logToTelemetry(error: Error, context?: Context) {
  datadogRum.addError(error, context);
}

export function toError(err: unknown) {
  return err instanceof Error ? err : new Error(String(err));
}

export const logError = (
  err: unknown,
  context: Context = {},
  options: Options = {}
) => {
  const error = toError(err);
  const { callback, controller } = options;

  // Ignore aborts because the call likely happened again immediately after
  if (controller?.signal?.aborted) return;

  if (isLocalDevEnvironment) {
    logToConsole(error, { err, ...context });
  } else {
    logToTelemetry(error, { err, ...context });
  }

  if (callback) callback(error);
};

const generateErrorLogger =
  (location: string, globalContext?: Partial<Context>, options?: Options) =>
  (err: unknown, instanceContext?: Partial<Context>) =>
    logError(
      err,
      {
        location,
        ...globalContext,
        ...instanceContext,
        BrowserCookieId: BrowserCookies.get('BrowserCookieId') || '',
        fullStoryId: BrowserCookies.get('fs_uid') || '',
        url: window.location.href
      },
      options
    );

export default generateErrorLogger;
